import Charts from "@components/charts";

const TopCompanies = ({ id, title, series, height = 400, loading }) => {
    const chartOptions = {
        chart: {
            type: "pie"
        },
        tooltip: {
            pointFormat: "<b>{point.name}</b>: {point.y} companies ({point.perc}%)"
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor          : "pointer",
                showInLegend    : true,
                dataLabels      : {
                    enabled: false
                },
                innerSize: "60%",
                center   : ["50%", "50%"]
            }
        },
        legend: {
            layout          : "vertical",
            align           : "right",
            verticalAlign   : "middle",
            itemMarginBottom: 10
        }
    };

    return (
        <Charts
            id={id}
            type="pie"
            height={height}
            loading={loading}
            series={series}
            cardHeader={{
                title,
                desc: ""
            }}
            {...chartOptions}/>
    );
};

export default TopCompanies;
